export const statusOptions = [
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];
